import styled, { css } from 'styled-components';
import { media } from 'utils/style';

import Summary from 'pages/Summary/component';

const mainStyles = css`
  flex-direction: 'row';
  max-width: 540px;
  align-items: stretch;
  min-height: 100%;
  /* align-items: baseline; */
  margin: 64px auto;

  ${media.lessThan('small')`
    max-width: calc(100vw - 60px);
  `};

  ${media.lessThan('extraSmall')`
    max-width: 100%;
    margin: 0;
  `};
`;

export default styled(Summary)`
  .main {
    ${mainStyles};
  }

  ${media.lessThan('extraSmall')`
    background: var(--white-caniche);
  `};
`;
